import {
  HTTP_INTERCEPTORS,
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { ToasterManagerService } from '../_services/toastr-manager.service';
import { LoadingService } from '../_services/loading.service';
import { AuthService } from '../_services/auth.service';

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private router: Router,
    private toastr: ToasterManagerService,
    private loadingService: LoadingService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    req = req.clone({
      withCredentials: true,
    });

    return next.handle(req).pipe(
      catchError((error) => {
        if (error instanceof HttpErrorResponse) {
          if (
            ![`${environment.api}/auth/login`].some((route) =>
              req.url.includes(route)
            ) &&
            error.status === 401
          ) {
            return this.handle401Error(error);
          }

          if ([400, 404].includes(error.status)) {
            return this.handle400Error(error);
          }

          if (error.status === 500) {
            return this.handle500Error(error);
          }
        }

        this.toastr.error('API communication error');
        return throwError(() => error);
      })
    );
  }

  private handle400Error(error: HttpErrorResponse) {
    if (!error.error.status && error.error.message) {
      const message = error.error.message;
      const errors = error.error.errors;

      if (errors && typeof errors === 'object') {
        for (let field in errors) {
          if (errors.hasOwnProperty(field)) {
            const messageOfError = errors[field];
            this.toastr.error(`${messageOfError}`);
          }
        }
      } else {
        this.toastr.warning(message);
      }
    } else {
      this.toastr.error('Erro Desconhecido');
    }

    return throwError(() => error);
  }

  private handle401Error(error: HttpErrorResponse) {
    this.loadingService.show();
    this.toastr.error('Session expired. Please login again!');

    this.authService.logout().subscribe({
      next: () => {
        this.router.navigate(['/']);
      },
      error: () => {
        this.router.navigate(['/']);
      },
    });

    this.loadingService.hide();
    return throwError(() => error);
  }

  private handle500Error(error: HttpErrorResponse) {
    this.toastr.error('An unexpected error occurred. Please try again later.');
    return throwError(() => error);
  }
}

export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: HttpRequestInterceptor, multi: true },
];
